export default __webpack_public_path__ + "static/media/68-BiteSizeEntertainement.535d252c.jpg";